'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$3() {
  this.az2 = null;
  this.az3 = false;
}
export { $c_Lpresto_AgentView$$anon$3 as $c_Lpresto_AgentView$$anon$3 };
$p = $c_Lpresto_AgentView$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$3;
/** @constructor */
function $h_Lpresto_AgentView$$anon$3() {
}
export { $h_Lpresto_AgentView$$anon$3 as $h_Lpresto_AgentView$$anon$3 };
$h_Lpresto_AgentView$$anon$3.prototype = $p;
$p.P = (function() {
  if ((!this.az3)) {
    this.az2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.az3 = true;
  }
  return this.az2;
});
var $d_Lpresto_AgentView$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$3, "presto.AgentView$$anon$3", ({
  DZ: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$3 as $d_Lpresto_AgentView$$anon$3 };
//# sourceMappingURL=presto.-Agent-View$$anon$3.js.map
